const staticPages = {
    comingSoon: 'Страница еще в разработке',
};

export default staticPages;
